// import React from "react";

// export default function BreakdownTable({
//   title = "Breakdown",
//   data = [],
//   selectedIds = [],
//   onSelectAll = () => {},
//   onSelectOne = () => {},
//   onChange = () => {},
//   onChange2 = () => {},
//   onAdd = () => {},
//   onDelete = () => {},
//   disableAdd = false,
//   hasQuantity = true,
//   showUOM = true,
//   showSKU = true,
//   showCost = false,
//   showAddButton = true,
//   disableQty = false,
//   checkbox = true,
//   showQuantityApprove = false,
//   disableQtyApprove = false,
// }) {
//   const isAllSelected = data.length > 0 && selectedIds.length === data.length;

//   return (
//     <div className="mt-4">
//       <div className="d-flex justify-content-between align-items-center">
//         <h6 className="mb-0 fw-bold" style={{ color: "#82c14a" }}>
//           {title}
//         </h6>
//         <div className="d-flex align-items-center gap-2">
//           {selectedIds.length > 0 && (
//             <button
//               type="button"
//               onClick={onDelete}
//               className="btn p-0 border-0"
//               style={{
//                 backgroundColor: "transparent",
//                 width: "36px",
//                 height: "36px",
//               }}
//               title="Delete selected items"
//             >
//               <i
//                 className="bi bi-trash"
//                 style={{ fontSize: "24px", color: "red" }}
//               ></i>
//             </button>
//           )}
//           {showAddButton && (
//             <button
//               type="button"
//               onClick={onAdd}
//               className="btn p-0 border-0"
//               disabled={disableAdd && !hasQuantity}
//               style={{
//                 backgroundColor: "transparent",
//                 width: "36px",
//                 height: "36px",
//                 opacity: !disableAdd || hasQuantity ? 1 : 0.5,
//                 cursor: !disableAdd || hasQuantity ? "pointer" : "not-allowed",
//               }}
//               title={
//                 !disableAdd || hasQuantity
//                   ? "Add item"
//                   : "Please fill out required fields before adding"
//               }
//             >
//               <i
//                 className="bi bi-plus-circle"
//                 style={{ fontSize: "24px", color: "#82c14a" }}
//               ></i>
//             </button>
//           )}
//         </div>
//       </div>

//       <div
//         className="table-responsive mt-2"
//         style={{ border: "1px solid #82c14a", borderRadius: "6px" }}
//       >
//         <table className="table mb-0">
//           <thead>
//             <tr>
//               {checkbox && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   <input
//                     type="checkbox"
//                     checked={isAllSelected}
//                     onChange={onSelectAll}
//                   />
//                 </th>
//               )}
//               {showSKU && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   SKU
//                 </th>
//               )}
//               <th
//                 scope="col"
//                 style={{ backgroundColor: "#82c14a", color: "white" }}
//               >
//                 Item Name
//               </th>
//               {showUOM && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   UOM
//                 </th>
//               )}
//               {showCost && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Cost
//                 </th>
//               )}
//               <th
//                 scope="col"
//                 style={{ backgroundColor: "#82c14a", color: "white" }}
//               >
//                 Quantity
//               </th>
//               {showQuantityApprove && (
//                 <th
//                   scope="col"
//                   style={{ backgroundColor: "#82c14a", color: "white" }}
//                 >
//                   Quantity Approve
//                 </th>
//               )}
//             </tr>
//           </thead>
//           <tbody>
//             {data.length > 0 ? (
//               data.map((row, index) => (
//                 <tr key={row.id || index}>
//                   {checkbox && (
//                     <td>
//                       <input
//                         type="checkbox"
//                         checked={selectedIds.includes(row.id)}
//                         onChange={(e) => onSelectOne(e, row.id)}
//                       />
//                     </td>
//                   )}
//                   {showSKU && <td>{row.sku}</td>}
//                   <td>{row.itemName}</td>
//                   {showUOM && <td>{row.uom?.name || ""}</td>}
//                   {showCost && <td>{row?.cost || ""}</td>}
//                   <td>
//                     <input
//                       type="number"
//                       min="0"
//                       disabled={disableQty}
//                       className="form-control form-control-sm text-center border-success"
//                       style={{ width: "80px", margin: "0 auto" }}
//                       value={row.quantity ?? ""}
//                       onChange={(e) => onChange(e, index)}
//                     />
//                   </td>
//                   {showQuantityApprove && (
//                     <td>
//                       <input
//                         type="number"
//                         min="0"
//                         disabled={disableQtyApprove}
//                         className="form-control form-control-sm text-center border-success"
//                         style={{ width: "80px", margin: "0 auto" }}
//                         value={row.quantityApprove ?? ""}
//                         onChange={(e) => onChange2(e, index)}
//                       />
//                     </td>
//                   )}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td
//                   colSpan={showUOM ? 5 : 5}
//                   className="text-center py-4 text-muted"
//                 >
//                   No items found. <br /> Please add item first.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

import React from "react";

export default function BreakdownTable({
  title = "Breakdown",
  data = [],
  selectedIds = [],
  onSelectAll = () => {},
  onSelectOne = () => {},
  onChange = () => {}, // quantity change
  onChange2 = () => {}, // quantityApprove change
  onAdd = () => {},
  onDelete = () => {},
  disableAdd = false,
  hasQuantity = true,
  showUOM = true,
  showSKU = true,
  showCost = false, // kept for backward-compat
  showAddButton = true,
  disableQty = false,
  checkbox = true,
  showQuantityApprove = false,
  disableQtyApprove = false,
  showQuantityReceivePartial = false,
  showRemaining = false,

  // NEW: toggles for the new columns / details row
  showPrice = false,
  showReference = false,
  showWarehouse = false,
  showDetailsRow = false, // shows Net Price / Discount under each row

  // NEW: handlers for the new cells/fields
  onPriceChange = () => {},
  onReferenceChange = () => {},
  onWarehouseChange = () => {},
  onNetPriceChange = () => {},
  onDiscountChange = () => {},
}) {
  const isAllSelected = data.length > 0 && selectedIds.length === data.length;

  // compute total colSpan for the details row / empty state
  const baseCols =
    (checkbox ? 1 : 0) +
    (showSKU ? 1 : 0) +
    1 + // Item Name
    (showUOM ? 1 : 0) +
    (showPrice ? 1 : 0) +
    (showReference ? 1 : 0) +
    (showWarehouse ? 1 : 0) +
    1 + // Quantity
    (showQuantityApprove ? 1 : 0) +
    (showRemaining ? 1 : 0);

  console.log("data", data);

  // Put these at the top of your component (once)
  const php = React.useMemo(
    () =>
      new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP" }),
    []
  );

  const toNum = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  };

  const totals = React.useMemo(() => {
    return (data || []).reduce(
      (acc, row) => {
        const qty = toNum(row?.quantity);
        const unitCost = toNum(row?.cost); // <-- use cost only
        const lineAmount = qty * unitCost;

        acc.qty += qty;
        acc.amount += lineAmount;
        return acc;
      },
      { qty: 0, amount: 0 }
    );
  }, [data]);

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center">
        <h6 className="mb-0 fw-bold" style={{ color: "#82c14a" }}>
          {title}
        </h6>
        <div className="d-flex align-items-center gap-2">
          {selectedIds.length > 0 && (
            <button
              type="button"
              onClick={onDelete}
              className="btn p-0 border-0"
              style={{
                backgroundColor: "transparent",
                width: "36px",
                height: "36px",
              }}
              title="Delete selected items"
            >
              <i
                className="bi bi-trash"
                style={{ fontSize: "24px", color: "red" }}
              />
            </button>
          )}
          {showAddButton && (
            <button
              type="button"
              onClick={onAdd}
              className="btn p-0 border-0"
              disabled={disableAdd && !hasQuantity}
              style={{
                backgroundColor: "transparent",
                width: "36px",
                height: "36px",
                opacity: !disableAdd || hasQuantity ? 1 : 0.5,
                cursor: !disableAdd || hasQuantity ? "pointer" : "not-allowed",
              }}
              title={
                !disableAdd || hasQuantity
                  ? "Add item"
                  : "Please fill out required fields before adding"
              }
            >
              <i
                className="bi bi-plus-circle"
                style={{ fontSize: "24px", color: "#82c14a" }}
              />
            </button>
          )}
        </div>
      </div>

      <div
        className="table-responsive mt-2"
        style={{ border: "1px solid #82c14a", borderRadius: "6px" }}
      >
        <table className="table mb-0">
          <thead>
            <tr>
              {checkbox && (
                <th
                  scope="col"
                  style={{ backgroundColor: "#82c14a", color: "white" }}
                >
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={onSelectAll}
                  />
                </th>
              )}
              {showSKU && (
                <th
                  scope="col"
                  style={{ backgroundColor: "#82c14a", color: "white" }}
                >
                  SKU
                </th>
              )}
              <th
                scope="col"
                style={{ backgroundColor: "#82c14a", color: "white" }}
              >
                Item Name
              </th>
              {showUOM && (
                <th
                  scope="col"
                  style={{ backgroundColor: "#82c14a", color: "white" }}
                >
                  UOM
                </th>
              )}
              {showCost && (
                <th
                  scope="col"
                  style={{ backgroundColor: "#82c14a", color: "white" }}
                >
                  Cost
                </th>
              )}
              {showPrice && (
                <th
                  scope="col"
                  style={{ backgroundColor: "#82c14a", color: "white" }}
                >
                  Price
                </th>
              )}
              {showReference && (
                <th
                  scope="col"
                  style={{ backgroundColor: "#82c14a", color: "white" }}
                >
                  Reference #
                </th>
              )}
              {showWarehouse && (
                <th
                  scope="col"
                  style={{ backgroundColor: "#82c14a", color: "white" }}
                >
                  Warehouse
                </th>
              )}
              <th
                scope="col"
                style={{ backgroundColor: "#82c14a", color: "white" }}
              >
                Quantity
              </th>
              {showRemaining && (
                <th
                  scope="col"
                  style={{ backgroundColor: "#82c14a", color: "white" }}
                >
                  Remaining
                </th>
              )}
              {showQuantityApprove && (
                <th
                  scope="col"
                  style={{ backgroundColor: "#82c14a", color: "white" }}
                >
                  Quantity Approve
                </th>
              )}
              {showQuantityReceivePartial && (
                <th
                  scope="col"
                  style={{ backgroundColor: "#82c14a", color: "white" }}
                >
                  Quantity Receive
                </th>
              )}
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((row, index) => (
                <React.Fragment key={row.id || index}>
                  <tr>
                    {checkbox && (
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedIds.includes(row.id)}
                          onChange={(e) => onSelectOne(e, row.id)}
                        />
                      </td>
                    )}
                    {showSKU && <td>{row.sku}</td>}
                    <td>{row.itemName}</td>
                    {showUOM && <td>{row.uom?.name || ""}</td>}
                    {showCost && <td>{row?.cost || ""}</td>}
                    {showPrice && <td>{row?.cost || ""}</td>}

                    {showReference && (
                      <td>
                        <input
                          type="text"
                          className="form-control form-control-sm text-center border-success"
                          style={{ width: 160, margin: "0 auto" }}
                          value={row.reference || ""}
                          onChange={(e) => onReferenceChange(e, index)}
                          placeholder="Ref #"
                        />
                      </td>
                    )}

                    {showWarehouse && (
                      <td>
                        {/* simple text input; swap to <select> if you have options */}
                        <input
                          type="text"
                          className="form-control form-control-sm text-center border-success"
                          style={{ width: 160, margin: "0 auto" }}
                          value={row.warehouse || row.warehouseName || ""}
                          onChange={(e) => onWarehouseChange(e, index)}
                          placeholder="Warehouse"
                        />
                      </td>
                    )}

                    {/* <td>
                      <input
                        type="number"
                        min="0"
                        disabled={disableQty}
                        className="form-control form-control-sm text-center border-success"
                        style={{ width: "80px", margin: "0 auto" }}
                        value={row.quantity ?? ""}
                        onChange={(e) => onChange(e, index)}
                      />
                    </td> */}
                    <td>
                      <input
                        type="number"
                        min="0"
                        step="any" // allow 1.5, 0.25, etc.
                        inputMode="decimal" // better mobile keyboard
                        disabled={disableQty}
                        className="form-control form-control-sm text-center border-success"
                        style={{ width: "120px", margin: "0 auto" }}
                        value={row.quantity ?? ""}
                        onChange={(e) => onChange(e, index)} // ensure you don't parseInt() later
                      />
                    </td>

                    {showRemaining && (
                      <td className="text-center">{row?.remaining || "0"}</td>
                    )}

                    {showQuantityApprove && (
                      <td>
                        <input
                          type="number"
                          min="0"
                          disabled={disableQtyApprove}
                          className="form-control form-control-sm text-center border-success"
                          style={{ width: "80px", margin: "0 auto" }}
                          value={row.quantityApprove ?? ""}
                          onChange={(e) => onChange2(e, index)}
                        />
                      </td>
                    )}

                    {showQuantityReceivePartial && (
                      <td>
                        <input
                          type="number"
                          min="0"
                          disabled={disableQtyApprove}
                          className="form-control form-control-sm text-center border-success"
                          style={{ width: "80px", margin: "0 auto" }}
                          // value={row.quantityReceivePartial ?? ""}
                          // value={row.quantityReceivePartial ?? ""}
                          onChange={(e) => onChange2(e, index)}
                          defaultValue={"0"}
                        />
                      </td>
                    )}
                  </tr>
                  {showDetailsRow && (
                    <tr>
                      <td colSpan={baseCols} style={{ background: "#fff" }}>
                        <div className="py-2 px-2">
                          {/* Net Price - row */}
                          <div className="d-flex  align-items-center mb-2">
                            <label
                              className="mb-0 me-2"
                              style={{ minWidth: 110 }}
                            >
                              Net Price :
                            </label>
                            <input
                              type="number"
                              min="0"
                              step="0.01"
                              className="form-control form-control-sm text-end"
                              style={{ width: 160 }}
                              value={row.netPrice ?? row.cost ?? ""}
                              onChange={(e) => onNetPriceChange(e, index)}
                              placeholder="100"
                            />
                          </div>

                          {/* Discount - row */}
                          <div className="d-flex  align-items-center mb-2">
                            <label
                              className="mb-0 me-2"
                              style={{ minWidth: 110 }}
                            >
                              Discount :
                            </label>
                            <input
                              type="number"
                              min="0"
                              step="0.01"
                              className="form-control form-control-sm text-end"
                              style={{ width: 160 }}
                              value={row.discount ?? ""}
                              onChange={(e) => onDiscountChange(e, index)}
                              placeholder="50"
                            />
                          </div>

                          {/* Total Amount (read-only) - row */}
                          <div className="d-flex  align-items-center">
                            <label
                              className="mb-0 me-2"
                              style={{ minWidth: 110 }}
                            >
                              Total Amount :
                            </label>
                            <input
                              type="number"
                              min="0"
                              step="0.01"
                              style={{ width: 160 }}
                              className="form-control form-control-sm text-end"
                              value={row?.cost * row?.quantity}
                              onChange={(e) => onDiscountChange(e, index)}
                              placeholder="50"
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan={baseCols} className="text-center py-4 text-muted">
                  No items found. <br /> Please add item first.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
